import { AxiosError } from 'axios';
import { GET_GROUP_RESIT_REGISTRATION_FEE_PROCESSING_STATUS } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { GET_GROUP_RESIT_FEE_PROCESSING_STATUS_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface FeeProcessingStatusResponse {
  errorMessage: string;
  status: ProcessingFileStatus;
  numberOfRecords: number;
  presignUrl: boolean;
}

export enum ProcessingFileStatus {
  ERROR = 'ERROR',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: FeeProcessingStatusResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
  refetchInterval?: number;
}

export const useGetFeeProcessingStatus = ({
  uuid,
  onSuccess,
  onError,
  enabled = false,
  refetchInterval = 5000,
}: Input) => {
  const getFeeProcessingStatus = async () => {
    const res = await axiosClient.get<FeeProcessingStatusResponse>(
      GET_GROUP_RESIT_REGISTRATION_FEE_PROCESSING_STATUS(uuid)
    );
    return res.data;
  };

  return useCustomQuery(GET_GROUP_RESIT_FEE_PROCESSING_STATUS_KEY, getFeeProcessingStatus, {
    onSuccess,
    onError,
    enabled,
    refetchInterval,
  });
};
